import client from "../api/client";
export const getList = () => {
  return client('/api/articles').then(({ data }) => data.data);
};

export const getPublished = () => {
  return client('/api/articles/published').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/articles/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/articles/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/articles', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/articles/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useArticleService () {
  return {
    getList,
    getPublished,
    addEditModel,
    getDetail,
    delModel,
  };
}
